import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import {toSnakeCase} from "../utils/general_utils";

function validarRut(rut) {
  rut = rut.replace(/\./g, '').replace(/-/g, '').replace(/\s+/g, '').toUpperCase();
  if (!/^\d{7,8}[0-9K]$/.test(rut)) return false;
  const aux = rut.slice(0, -1);
  const dv = rut.slice(-1);
  const revertido = Array.from(aux).reverse().map(Number);
  const factores = [2,3,4,5,6,7];
  let suma = 0;
  for (let i = 0; i < revertido.length; i++) {
    suma += revertido[i] * factores[i % factores.length];
  }
  const res = (11 - (suma % 11)) % 11;
  if (res === 10) return dv === 'K';
  if (res === 11) return dv === '0';
  return dv === res.toString();
}

function formatearRut(rut) {
  rut = rut.replace(/^0+/, '').replace(/\./g, '').replace(/-/g, '').replace(/\s+/g, '');
  if (rut.length <= 1) return rut;
  const cuerpo = rut.slice(0, -1);
  const dv = rut.slice(-1);
  return `${cuerpo}-${dv}`;
}

export default function InputRut(props) {
  const [errorRut, setErrorRut] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorApellido, setErrorApellido] = useState(false);

  useEffect(() => {
    // Informa errores al padre si hay alguno y el switch está activo
    props.errorRut((errorRut || errorEmail || errorNombre || errorApellido) && props.checked);
  }, [errorRut, errorEmail, errorNombre, errorApellido, props.checked]);

  const handleRutChange = (e) => {
    const input = e.target.value;
    const valido = validarRut(input);
    setErrorRut(!valido && props.checked);
    props.handleRut(formatearRut(input));
  };

  const handleEmailChange = (e) => {
    const input = e.target.value;
    const valido = input.trim() === '' || /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(input);
    setErrorEmail(!valido && props.checked);
    props.handleEmail(input);
  };

  const handleNombreChange = (e) => {
    const input = e.target.value;
    const valido = input.trim() !== '';
    setErrorNombre(!valido && props.checked);
    props.handleNombre(input);
  };

  const handleApellidoChange = (e) => {
    const input = e.target.value;
    const valido = input.trim() !== '';
    setErrorApellido(!valido && props.checked);
    props.handleApellido(input);
  };

  return (
    <FormControl sx={{ width: '100%' }}>
      <Box
        sx={{
          m: props.margin ?? 1,
          width: '100%',
          background: props.checked ? '#BBDEFB' : '#E4E4E4',
          borderRadius: '0.5rem',
          p: '2%'
        }}
      >
        <Grid container spacing={2}>
          <Grid size={12}>
          <FormControlLabel
            test_id={toSnakeCase("Switch_representante_temporal")}
            control={<Switch checked={props.checked} onChange={props.handleSwitch} />}
            label={
              <>
                REPRESENTANTE TEMPORAL{" "}
                <Typography component="span" variant="caption" sx={{ color: 'text.secondary' }}>
                  (persona perteneciente al establecimiento que pueda validar este acuerdo; p. ej.: profesor, inspector, etc.)
                </Typography>
              </>
            }
          />
        </Grid>

          <Grid size={6}>
            <TextField test_id={toSnakeCase("nombre_temp")}
              required
              label="Nombre"
              size="small"
              helperText={errorNombre && props.checked ? 'Nombre requerido' : ''}
              error={errorNombre && props.checked}
              value={props.nombre_temp}
              disabled={!props.checked}
              fullWidth
              onChange={handleNombreChange}
            />
          </Grid>

          <Grid size={6}>
            <TextField test_id={toSnakeCase("apellido_temp")}
              required
              label="Apellidos"
              size="small"
              helperText={errorApellido && props.checked ? 'Apellidos requeridos' : ''}
              error={errorApellido && props.checked}
              value={props.apellido_temp}
              disabled={!props.checked}
              fullWidth
              onChange={handleApellidoChange}
            />
          </Grid>

          <Grid size={6}>
            <TextField
              required test_id={toSnakeCase("rut_temp")}
              label="RUT Representante temporal"
              size="small"
              helperText={errorRut && props.checked ? 'RUT inválido' : '(12345678-9)'}
              error={errorRut && props.checked}
              value={props.rut}
              disabled={!props.checked}
              fullWidth
              onChange={handleRutChange}
            />
          </Grid>

          <Grid size={6}>
            <TextField test_id={toSnakeCase("email_temp")}
              label="Email Representante Temporal"
              size="small"
              helperText={errorEmail && props.checked ? 'Email no válido' : ''}
              error={errorEmail && props.checked}
              value={props.email}
              disabled={!props.checked}
              fullWidth
              onChange={handleEmailChange}
            />
          </Grid>

          <Grid size={12}>
            <Typography fontSize="12px">
              **Si por fuerza mayor el Representante del colegio no se encuentra en el establecimiento debe ingresar a un Representante temporal que cumpla el rol de ministro de fe del proceso y debe contar con Clave Única para firmar el documento.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </FormControl>
  );
}
